

class UmiStorage {
  constructor(fallback) {
    this.store = this.storageAvailability('localStorage') && !fallback ?
      localStorage : new DummyStore();
  }

  storageAvailability(type) {
    try {
      var storage = window[type],
      x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch(e) {
      return e instanceof DOMException && (
        // everything except Firefox
        e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage.length !== 0;
    }
  }

  getItem(item) {
    return this.store.getItem(item);
  }

  setItem(item, value) {
    this.store.setItem(item, value);
  }

  removeItem(item) {
    this.store.removeItem(item);
  }
}

export default UmiStorage;

/**
 * DummyStore represents a Storage fallback
 * Fallback may be intended or not
 */
class DummyStore {
  constructor() {
    this.store = {};
  }

  getItem(item) {
    return this.store[item];
  }

  setItem(item, value) {
    this.store[item] = value;
  }

  removeItem(item) {
    delete this.store[item];
  }
}


// WEBPACK FOOTER //
// ../UmiCore/src/UmiStorage.js